<template>
  <AppShowMutationFeedback
    v-if="guidanceMessages.length > 0"
    :feedback-messages="guidanceMessages"
    class="mb-5"
  />
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";

import AppShowMutationFeedback from "./AppShows/AppShowMutationFeedback.vue";

export default defineComponent({
  name: "GuidanceMessages",
  components: {
    AppShowMutationFeedback
  },
  props: {
    location: {
      type: String,
      required: true
    },
    entityType: {
      type: String,
      required: true
    },
    entityId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      guidanceMessages: []
    };
  },
  apollo: {
    guidanceMessages: {
      query: gql`
        query guidanceMessages(
          $location: String
          $entityType: String
          $entityId: ID
        ) {
          guidanceMessages(
            location: $location
            entityType: $entityType
            entityId: $entityId
          ) {
            ${AppShowMutationFeedback.fragments.translationFields}
          }
        }
      `,
      variables() {
        return {
          location: this.location,
          entityType: this.entityType,
          entityId: this.entityId
        };
      },
      fetchPolicy: "cache-first"
    }
  }
});
</script>
